import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styles from '../index.module.css';
import { getMarcoLegal } from '../../service/apiBackEnd'
import { getResRegulatorias, getMultasRegulatorias } from '../../service/apiBackEnd'


const MarcoRegulatorio = () => {

  const [allData, setAllData] = useState([]);
  const [allMultas, setAllMultas] = useState([]);
  const [enrichedData, setEnrichedData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getMarcoLegal();
      console.log("DATA", res);
      setAllData(res);
    };
    fetchData();
  }, []);

  console.log("DATAAAA", allData);
  
   useEffect(() => {
          const fetchData = async () => {
              const res = await getMultasRegulatorias();
              console.log("MULTAS", res);
              setAllMultas(res);
          };
          fetchData();
      }, []);
  
      useEffect(() => {
          const getMediaUrl = async (mediaId) => {
              try {
                  const response = await fetch(`http://epas.test.di.dgi.loc/wp-json/wp/v2/media/${mediaId}`);
                  const mediaData = await response.json();
                  return mediaData.source_url;
              } catch (error) {
                  console.error("Error fetching media:", error);
                  return null;
              }
          };
  
          const fetchMediaUrls = async () => {
              const updatedData = await Promise.all(
                  allMultas.map(async (elem) => {
                      const multa = elem.acf?.multas
                          ? await getMediaUrl(elem.acf.multas)
                          : null;
  
                      return { ...elem, multa };
                  })
              );
              setEnrichedData(updatedData);
          };
  
          if (allMultas.length > 0) {
              fetchMediaUrls();
          }
      }, [allMultas]);
  
      console.log("multas", allMultas)

  return (
    <Container>

      <h1 className="mt-5 mb-4">Marco Regulatorio</h1>

      {/* <h3 className="mt-5 mb-4">Resoluciones regulatorias</h3>
      <hr></hr> */}
      <Row>

        {allMultas.map((elem) => {
          console.log(elem)
          return (
            <>
              <h6>{elem.acf.titulo}</h6>
              {elem.acf.multas && (
                <a href={elem.acf.multas}
                  style={{ width: "fit-content", marginBottom: "1em" }}
                  target="_blank" rel="noopener noreferrer"
                  download className={styles.btnDescarga}>
                  Descargar Archivo
                </a>
              )}
            </>
          )
        })}
      </Row>
      <hr></hr>
      {/* <Row>
        <h3>Emergencia Hidrica</h3>
        {
          allData.map((item, index) => (
            <div key={index}>
              <div
                dangerouslySetInnerHTML={{
                  __html: item.acf?.emergencia_hidrica_provincial_decretos,
                }}
              />
              <hr />
            </div>
          ))
        }
      </Row> */}
      <Row>
        <h3>AYSAM SAPEM (Aguas Mendocinas)</h3>
        {
          allData.map((elem, index) => (
            <div>
              <h5>Contrato de Concesión (texto principal)</h5>
              {elem.acf.aysam_sapem_aguas_mendocinas_
                && (
                  <a href={elem.acf.aysam_sapem_aguas_mendocinas_}
                    style={{ width: "fit-content", marginBottom: "1em" }}
                    target="_blank" rel="noopener noreferrer"
                    download className={styles.btnDescarga}>
                    Descargar Archivo
                  </a>
                )}
              <h5>Decreto OSMSA</h5>
              {elem.acf.decreto_osmsa
                && (
                  <a href={elem.acf.decreto_osmsa}
                    style={{ width: "fit-content", marginBottom: "1em" }}
                    target="_blank" rel="noopener noreferrer"
                    download className={styles.btnDescarga}>
                    Descargar Archivo
                  </a>
                )}
            </div>
          ))
        }
      </Row>
    </Container>
  )
}

export default MarcoRegulatorio